import checkedIcon from '../../assets/Login/checked.png';
import unSelectIcon from '../../assets/Login/unselect.png';
import { LocalImage } from '../Image';
import styles from './index.module.scss';
import cls from 'classnames';

export interface CheckInputProps {
  checked: boolean;
  setChecked: (updater: (checked: boolean) => boolean) => void;
}

export function CheckInput({ checked, setChecked }: CheckInputProps) {
  return (
    <LocalImage
      className={cls(styles.checkbox, {})}
      src={checked ? checkedIcon : unSelectIcon}
      onClick={() => {
        setChecked((v) => !v);
      }}
    />
  );
}
